'use strict';

exports.__esModule = true;
exports.default = {
  SMALL: 'small',
  LARGE: 'large'
};
//# sourceMappingURL=LikeSize.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/constants/LikeSize.js
// module id = 871
// module chunks = 67997519577666